export const hy = {
    "n1": "Գլխավոր",
    "n2": "Պատվերներ",
    "n3": "Գործարքներ",
    "n4": "Թիմ",
    "n5": "Իմ էջը",
  
    "t1": "Սխալ է տեղի ունեցել",
    "t2": "Պատճենումը հաջողվեց",
    "t3": "Խնդրում ենք լրացնել ամբողջ տեղեկատվությունը",
    "t4": "Բեռնվում է…",
    "t5": "Մուտքը հաջողվեց",
    "t6": "Գնահատականը պետք է լինի 3-ից բարձր",
    "t7": "Ուղարկումը հաջողվեց",
    "t8": "Մնացորդը բավարար չէ",
    "t9": "Ուղարկումը ձախողվեց",
    "t10": "Խնդրում ենք նախ կապել հասցեն, շուտով կտեղափոխվեք անձնական էջ",
    "t11": "Հասցեն արդեն կապված է, խնդրում ենք դիմել աջակցությանը",
    "t12": "Փոփոխությունը հաջողվեց",
    "t13": "Փոփոխությունը ձախողվեց",
    "t14": "Խնդրում ենք դիմել աջակցությանը՝ գաղտնաբառը փոխելու համար",
    "t15": "Գաղտնաբառի ձևաչափը սխալ է",
    "t16": "Ելքագրումը հաջողվեց",
    "t17": "Առավելագույն ելքագրում",
    "t18": "Նվազագույն ելքագրում",
    "t19": "Գաղտնաբառերը չեն համընկնում",
    "t20": "Ծանուցում",
    "t21": "Ժամանակավորապես հնարավոր չէ անցնել",
    "t22": "Գաղտնաբառի ձևաչափը սխալ է",
    "t23": "Գրանցումը հաջողվեց",
    "t24": "Մուտքագրեք երկրի կոդը",
    "t25": "Ավելին չկա",
  
    "l1": "Լեզու",
    "l2": "Մուտքագրեք հաշիվը",
    "l3": "Մուտքագրեք գաղտնաբառը",
    "l4": "Հիշել",
    "l5": "Մուտք",
    "l6": "Գրանցվել",
    "l7": "Չունե՞ք հաշիվ",
    "l8": "Հեռախոսահամար",
    "l9": "Մականուն",
    "l10": "Գաղտնաբառ",
    "l11": "Հաստատեք գաղտնաբառը",
    "l12": "Հրավերի կոդ",
    "l13": "Գրանցում",
    "l14": "Արդեն ունե՞ք հաշիվ",
    "l15": "Մուտք գործել",
    "l16": "Մուտքագրեք 6-16 նիշանոց թվային գաղտնաբառ",
  
    "bz1": "Օգնություն",
    "bz2": "Հաճախ տրվող հարցեր",
    "bz3": "Գործարքի կանոններ",
    "bz4": "Ինչպես հանել գումարը",
    "bz5": "Ինչպես լիցքավորել",
  
    "bz6": "1. Ի՞նչ է ebay Review RoBoT-ը",
    "bz7": "ebay Review RoBoT-ը մարքեթինգային ընկերություն է, որը օգնում է վաճառողներին մեծացնել վաճառքները և դիտումները։ Այն ստեղծում է շահավետ մոդել վաճառողների և օգտատերերի միջև։",
    "bz8": "2. Ինչպե՞ս է աշխատում ebay Review RoBoT-ը",
    "bz9": "Օգտատերը սեղմում է պատվերը, համակարգը ստեղծում է այն ավտոմատ։ Վճարումը կատարվում է USDT-ով և ստացվում է կոմիսիա։",
    "bz10": "3. Ինչու են գները տարբերվում",
    "bz11": "Գների տարբերությունը կախված է ցանցից, արագությունից, տարածաշրջանից և այլ գործոններից։",
    "bz12": "4. Շահույթ",
    "bz13": "Ավելի բարձր արժեք ունեցող պատվերները տալիս են ավելի բարձր շահույթ։",
    "bz14": "Օրական ստեղծվում է 60 պատվեր, յուրաքանչյուրի համար 0.6% կոմիսիա։",
    "bz15": "60 պատվերից հետո կարելի է հանել գումարը։",
    "bz16": "Յուրաքանչյուր հաշիվ կարող է կապվել միայն մեկ USDT հասցեի հետ։",
    "bz17": "Ելքագրումը կատարվում է 24 ժամվա ընթացքում։",
    "bz18": "Լիցքավորումից առաջ կապեք ձեր TRC20 հասցեն։",
    "bz19": "Հաշիվների միջև փոխանցումները արգելված են։",
  
    "ty1": "Հաստատել",
    "ty2": "Չեղարկել",
    "ty3": "Ուղարկել",
    "ty4": "TRC20 հասցե",
    "ty5": "ERC20 հասցե",
  
    "s1": "Ընդհանուր եկամուտ",
    "s2": "Ծառայություն",
    "s3": "Մեր մասին",
    "s4": "Օգնություն",
    "s5": "Գործընկերներ",
    "s6": "Իմ ծառայությունները",
  
    "d1": "Անավարտ",
    "d2": "Ավարտված",
    "d3": "Տվյալներ չկան",
    "d4": "Պատվերի համար",
    "d5": "Գործարքի ժամանակ",
    "d6": "Գումար",
    "d7": "Ընթացիկ առաջադրանքներ",
    "d8": "Սպասվող եկամուտ",
    "d9": "Մնացել է",
    "d10": "Գնահատական",
  
    "j1": "Հաշվի մնացորդ",
    "j2": "Գործարքի նկարագրություն",
    "j3": "Օգտատերը կատարում է պատվերներ և ստանում կոմիսիա։",
    "j4": "Սկսել",
    "j5": "Այսօրվա եկամուտ",
    "j6": "Ավարտված",
    "j7": "Ընդհանուր առաջադրանքներ",
  
    "td1": "Մնացորդ",
    "td2": "Կոմիսիա",
    "td3": "Ստանալ",
    "td4": "Ընդհանուր մարդիկ",
    "td5": "Օգտատերեր",
    "td6": "Ներդրում",
    "td7": "Քանակ",
    "td8": "Կարգավիճակ",
  
    "g1": "Ելքագրում",
    "g2": "Լիցքավորում",
    "g3": "Հրավիրել ընկերներին",
    "g4": "Հրավիրել հիմա",
    "g5": "Ստացեք կոմիսիա ձեր ընկերների շահույթից",
    "g6": "Անձնական տվյալներ",
    "g7": "Ֆինանսական պատմություն",
    "g8": "Լիցքավորման պատմություն",
    "g9": "Ելքագրման պատմություն",
    "g10": "Լեզու",
    "g11": "Դուրս գալ",
    "g12": "Վստահ ե՞ք, որ ցանկանում եք դուրս գալ",
  
    "yh1": "Օգտատիրոջ տվյալներ",
    "yh2": "Փոփոխել",
    "yh3": "Կարգավորումներ",
    "yh4": "Հեռախոս",
    "yh6": "Հին գաղտնաբառ",
    "yh7": "Նոր գաղտնաբառ",
  
    "mx1": "Կոմիսիա",
    "mx2": "Եկամուտ",
    "mx3": "Մերժված",
    "mx4": "Ժամանակ",
    "mx5": "Լիցքավորումը հաջողվեց",
    "mx6": "Մերժված",
    "mx7": "Սպասման մեջ",
    "mx8": "Հասցե",
    "mx9": "Մատչելի մնացորդ",
    "mx10": "Փաստացի ստացված",
    "mx11": "Մուտքագրեք գումարը",
  
    "cz2": "Պատճենել",
    "cz3": "Արժույթ ընտրել",
    "cz4": "Վճարել",
    "cz5": "Միայն TRC20-USDT",
    "cz6": "Միայն ERC20",
  
    "qy1": "Կոդ",
  
    "yq1": "Հրավիրել ընկերներին",
    "yq2": "Հրավերի կոդ",
    "yq3": "Հրավիրեք և վաստակեք",
    "yq4": "Հրավիրել",
  
    "zf1": "Վճարման եղանակ",
    "zf2": "Ընտրեք",
    "zf3": "Արժույթ",
    "zf4": "Ցանց",
    "zf5": "Անցնել գործարքի",
    "zf6": "Պատճենումը հաջողվեց",
    "zf7": "Արժույթ",
    "zf8": "Խնդրում ենք օգտագործել",
    "zf9": "Ուղարկեք հասցեին",
    "zf10": "Արժույթի տեսակ",
    "zf11": "Պատճենել",
    "zf12": "Ստուգեք հասցեն",
    "zf13": "Ժամանակ",
    "zf14": "1~5 րոպե",
    "zf15": "Նվազագույն գումար",
  
    "a1": "Մարքեթինգային կենտրոն",
    "a2": "Օգնում է բարձրացնել վաճառքները",
    "a3": "Օգտատերը կատարում է պատվերներ և ստանում եկամուտ",
    "a4": "Համակարգը մշտապես բարելավվում է",
    // Հաճախորդների սպասարկում
    "kf1": "Առցանց հաճախորդների սպասարկում",
    "kf2": "Ձեռքով հաճախորդների սպասարկման միջոցով կանխիկացում",
    "kf3": "Կարող եք սեղմել այստեղ՝ կապ հաստատելու ձեռքով հաճախորդների սպասարկման հետ կանխիկացման համար",
    "kf4": "Ձեռքով հաճախորդների սպասարկման միջոցով լիցքավորում",
    "kf5": "Կարող եք սեղմել այստեղ՝ կապ հաստատելու ձեռքով հաճախորդների սպասարկման հետ լիցքավորման համար",
    // Վճարման ընտրանքների պատուհան
    "zf16": "Բանկային քարտով գործարքների համար դիմեք հաճախորդների սպասարկմանը",
    "zf17": "Կապվել հաճախորդների սպասարկման հետ"
  }